export default "__VITE_ASSET__D6E65txB__"